module.exports = __webpack_public_path__ + "static/media/news-heather.303bf282.jpg";